import {base, baseConfig} from '../Services/api';

export function getAbsences(options) {
  const url = new URL(`${base}absences`);
  Object.entries(options).forEach(([key, value]) => url.searchParams.set(key, value));
  return fetch(url, baseConfig);
}
